import angerIcebergThumbnail from "@/assets/anger-iceberg-introduction-thumbnail.png";
import imaginationVideo from "@/assets/videos/exercises/anger-iceberg/anger-iceberg-intro.webm";
import AngerIcebergFlow from "@/components/Exercises/Anger-Iceberg/AngerIcebergFlow";
import { Button } from "@/components/ui/button";
import { ExerciseLayout } from "@/components/ui/exercise-layout";
import SubtitleLanguageSwitcher from "@/components/ui/SubtitleLanguageSwitcher";
import {
  VideoWithSubtitles,
  type VideoWithSubtitlesRef,
} from "@/components/ui/VideoWithSubtitles";
import { useLocale } from "@/contexts/IntlContext";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useRef, useState } from "react";
import { useChildSessionStore } from "@/lib/stores/childSessionStore";
import { FormattedMessage } from "react-intl";

export const Route = createFileRoute(
  "/(content)/children/exercises/(shared)/anger-iceberg/"
)({
  component: RouteComponent,
  beforeLoad: () => ({
    title: "angerIceberg.title",
    navbar: {
      showTitle: true,
    },
  }),
});

function RouteComponent() {
  const { locale } = useLocale();
  const [showExercise, setShowExercise] = useState(false);
  const [subtitleLanguage, setSubtitleLanguage] = useState<"ar" | "en">(locale);
  const videoRef = useRef<VideoWithSubtitlesRef>(null);
  const { selectedEmotionId, reset } = useChildSessionStore();
  const navigate = useNavigate();

  const handleButtonClick = () => {
    const video = videoRef.current?.video;
    if (!video) return;
    video.pause();
    setShowExercise(true);
  };

  const handleComplete = () => {
    setShowExercise(false);
    videoRef.current?.resetVideo();
    if (selectedEmotionId) {
      navigate({ to: "/children/session" });
    }
  };

  const handleExit = () => {
    setShowExercise(false);
    videoRef.current?.resetVideo();
    if (selectedEmotionId) {
      reset();
      navigate({ to: "/children/exercises" });
    }
  };

  const subtitleTracks = [
    {
      src: "/subs/anger-iceberg-intro.ar.vtt",
      srcLang: "ar",
      label: "العربية",
      default: subtitleLanguage === "ar",
    },
    {
      src: "/subs/anger-iceberg-intro.en.vtt",
      srcLang: "en",
      label: "English",
      default: subtitleLanguage === "en",
    },
  ];

  return (
    <ExerciseLayout
      contentClassName="py-7.5 space-y-18"
      actions={
        <Button className="w-full" onClick={handleButtonClick}>
          <FormattedMessage id="relaxationExercise.startExercise" />
        </Button>
      }
    >
      <div className="space-y-2">
        <h3 className="text-h3 font-medium">
          <FormattedMessage id="breathing.intro.title" />
        </h3>

        <SubtitleLanguageSwitcher
          subtitleLanguage={subtitleLanguage}
          onLanguageChange={setSubtitleLanguage}
        />

        <VideoWithSubtitles
          ref={videoRef}
          src={imaginationVideo}
          poster={angerIcebergThumbnail}
          subtitleTracks={subtitleTracks}
          activeSubtitleLanguage={subtitleLanguage}
          loop={false}
        />
      </div>

      <AngerIcebergFlow
        onComplete={handleComplete}
        onExit={handleExit}
        isShow={showExercise}
      />
    </ExerciseLayout>
  );
}

